import type { VFormFilterButtonProps } from '@modules/form-widgets/components/VFormFilterButton/types';
import type { IFormPlainDataListboxItem } from '@modules/forms/types';
import type { Permission } from '@modules/permissions/utils';
import type { ISmartFilterColumnData, ISmartFilterColumnDataPayload } from '@modules/smart-filters/types';

import type { ReportType, ReportWidgetType } from '../enums';

export interface IReportQueryOptions {
  permission: Permission;
  reportType: ReportType;
  widgetType: ReportWidgetType;
}

export enum EGroupNames {
  AFFILIATE = 'affiliate',
  PLAYER = 'player',
  DATE = 'date',
  ROW_ON_PAGE = 'row_on_page',
}

export interface IGroupOptions {
  [EGroupNames.AFFILIATE]: string[];
  [EGroupNames.DATE]: string[];
  [EGroupNames.PLAYER]: string[];
  [EGroupNames.ROW_ON_PAGE]: number[];
}

export type IGroupSortableOptions = Pick<IGroupOptions, EGroupNames.AFFILIATE>;

export type IGroupOptionsResponse = IGroupOptions & IGroupSortableOptions;

export interface IReportOptionsResponse {
  group_by: IGroupOptionsResponse;
}

export interface IReportTab {
  id: number;
  name: Maybe<string>;
  aasm_state?: string;
  read_only?: boolean;
}

export interface IReportTabsResponse {
  list: IReportTab[];
  tabs_list: number[];
  locale_key?: string;
}

export interface IReportAddTabResponse {
  segment: IReportTab;
  structure?: IReportTab;
}

export interface IReportInnerTabItem {
  id: number;
  shortcode: string;
  advancedFilter?: boolean;
  uploadFile?: boolean;
}

export interface IReportTabItem extends IReportTab, VFormFilterButtonProps, Omit<IReportInnerTabItem, 'id'> {
  isActive?: boolean;
}

export interface IReportQueryOptionsPayload {
  options: IReportQueryOptions;
  tabId: number;
}

export interface IReportChangeTabNamePayload extends IReportQueryOptionsPayload {
  report_segment?: {
    name: string;
  };
  report_structure?: {
    name: string;
  };
}

export type IReportStructureStates = string[];

export interface IReportStructureStatesResponse {
  stucture_states: IReportStructureStates;
}

export interface IReportChangeStructureStatePayload extends IReportQueryOptionsPayload {
  report_structure: {
    aasm_state: string;
  };
}

export type IReportStatsData = Record<string, ISmartFilterColumnData>;

export type IReportTabsData = IFormPlainDataListboxItem<string | number>[];

export type IReportInnerTabResponse = IReportTabsData | IReportStatsData;

export interface IReportChangeInnerTabPayload extends IReportQueryOptionsPayload {
  add: boolean;
  innerTabId: number | string;
  segment_tab?: {
    data: ISmartFilterColumnDataPayload;
  };
  structure_tab?: {
    data: ISmartFilterColumnDataPayload;
  };
}

export interface IReportUploadFilePayload extends IReportQueryOptionsPayload {
  innerTabId: number | string;
  formData: FormData;
}
